import {Collapse, Grid} from "@mui/material";
import {useCallback, useState} from "react";
import WidgetSwitch from "../../atomicComponents/WidgetSwitch";
import MhdWidgetDivider from "../../atomicComponents/MhdWidgetDivider";
import MhdMarkerSymbolChoices from "../../atomicComponents/MhdMarkerSymbolChoices";
import MhdLineWidthChoices from "../../atomicComponents/MhdLineWidthChoices";
import MhdLineStyleChoices from "../../atomicComponents/MhdLineStyleChoices";
import MhdDiscreteSlider from "../../atomicComponents/MhdDiscreteSlider";
import MhdSolidColorWidget from "../../atomicComponents/MhdSolidColorWidget";
import {setAndUpdate, validateAndUpdate} from "../../../utils/helpers";
import MhdSelect from "../../atomicComponents/MhdSelect";
import {unitChoices} from "../../../utils/choices";
import MhdSwitch from "../../atomicComponents/MhdSwitch";
import MhdInput from "../../atomicComponents/MhdInput";

const SliceWidget = ({data, mods, warn, errs, update, setter}) => {

  const [customizeStyle, setCustomizeStyle] = useState(false)

  return (
    <Grid container spacing={1}>
      <Grid item xs={4}>
        <MhdSwitch
          label='Show Sign Only'
          value={data.show_sign_only}
          onChange={useCallback((v) => setAndUpdate('show_sign_only', v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={4}>
        <MhdSwitch
          label='Apply CI'
          value={data.ci}
          onChange={useCallback((v) => setAndUpdate('ci', v, setter, update), [])}
        />
      </Grid>
      <Grid item xs={4}>
        <MhdSwitch
          label='Show Fill Color'
          value={data.show_fill_color}
          onChange={useCallback((v) => setAndUpdate('show_fill_color', v, setter, update), [])}
        />
      </Grid>
              <Grid item xs={12}>
                <Collapse in={data.ci}>
                  <MhdInput
                    label="Sampling Radius"
                    value={data.sampling_radius}
                    override={mods.sampling_radius}
                    warning={warn.sampling_radius}
                    error={errs.sampling_radius}
                    units={'°'}
                    onChange={useCallback((v) => validateAndUpdate("sampling_radius", v, setter, update), [])}
                  />
                </Collapse>
              </Grid>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label="SMOOTH DATA"
            value={data.smooth}
            onChange={useCallback((v) => setAndUpdate('smooth', v, setter, update), [])}
        >
          <Collapse in={data.smooth} >
            <Grid container spacing={1} pt={"2px"}>
              <Grid item xs={12}>
                <MhdDiscreteSlider
                  label="Rolling Average (hrs)"
                  value={data.rolling_average}
                  override={mods.rolling_average}
                  warning={warn.rolling_average}
                  error={errs.rolling_average}
                  onChange={useCallback((v) => setAndUpdate("rolling_average", v, setter, update), [])}
                  units={'hrs'}
                />
              </Grid>
              <Grid item xs={6}>
                <WidgetSwitch
                  label="Include Missing Values"
                  value={data.include_nans}
                  onChange={useCallback((v) => setAndUpdate("include_nans", v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={6}>
                <WidgetSwitch
                  label="Interpolate Missing Values"
                  value={data.interpolate_missing_values}
                  onChange={useCallback((v) => setAndUpdate("interpolate_missing_values", v, setter, update), [])}
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
      <Grid item xs={12}>
        <MhdWidgetDivider
            label='CUSTOMIZE STYLE'
            value={customizeStyle}
            onChange={setCustomizeStyle}
        >
          <Collapse in={customizeStyle} >
            <Grid container spacing={1} pt={'2px'}>
              <Grid item xs={3}>
                <MhdSolidColorWidget
                  label='Line Color'
                  value={data.color}
                  onChange={useCallback((v) => setAndUpdate('color', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={3}>
                <MhdMarkerSymbolChoices
                  label='Symbols'
                  value={data.marker_symbol}
                  onChange={useCallback((v) => setAndUpdate('marker_symbol', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={3}>
                <MhdLineWidthChoices
                  label='Line Width'
                  value={data.line_width}
                  onChange={useCallback((v) => setAndUpdate('line_width', v, setter, update), [])}
                />
              </Grid>
              <Grid item xs={3}>
                <MhdLineStyleChoices
                  label='Line Style'
                  value={data.line_style}
                  onChange={useCallback((v) => setAndUpdate('line_style', v, setter, update), [])}
                />
              </Grid>
            </Grid>
          </Collapse>
        </MhdWidgetDivider>
      </Grid>
    </Grid>
  );
}

export default SliceWidget;